import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAPI } from "../contexts/APIContext";
import VideoPlayer from "../components/VideoPlayer";
import LoadingScreen from "../components/LoadingScreen";

const StandalonePlayer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { apiClient } = useAPI();
  const [episode, setEpisode] = useState(null);
  const [show, setShow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [showResult, episodesResult] = await Promise.all([
          apiClient.getStoriverseShow(id),
          apiClient.getStoriverseEpisodes(id),
        ]);

        if (!showResult.status) throw new Error(showResult.error || "Failed to load show");
        if (!episodesResult.status) throw new Error(episodesResult.error || "Failed to load episodes");

        const episodes = episodesResult.data || [];
        if (episodes.length === 0) throw new Error("No episodes found");

        const withVideo = episodes.find((ep) => ep?.file_url);
        if (!withVideo?.file_url) {
          throw new Error("No video URL for this show");
        }

        setShow(showResult.data);
        setEpisode(withVideo);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, apiClient]);

  if (loading) return <LoadingScreen message="Loading..." />;
  if (error) return <div style={{ color: "white", padding: "2rem" }}>{error}</div>;

  return (
    <VideoPlayer
      isOpen={true}
      onClose={() => navigate("/storyverse")}
      videoUrl={episode.file_url}
      title={show?.name || episode.name}
      description={episode.description}
      episodeId={episode.id}
      showId={id}
      storyId={episode.id}
      isStoryverse={true}
    />
  );
};

export default StandalonePlayer;
